import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action, observable, computed } from 'mobx';
import moment from 'moment';

import { Tabs } from '../component/Tabs';
import { Dropdown } from '../component/Dropdown';
import { DayPickerYMD } from '../component/DayPicker';
import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';
import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';
import translateBase from '../../translate';
let translate = translateBase.bindPage('userProfile');

class TypeaheadSelector {

  @observable typedValue;

  @action.bound handleNewSelection() {
    this.typedValue = undefined;
  }

  @action.bound handleChange(event) {
    this.typedValue = event.target.value;
  }

  filtered = (options) => {
    if (!this.typedValue) {
      return options;
    } else {
      return options.filter(opt => {
        return (opt.text || '').toLowerCase().indexOf(this.typedValue.toLowerCase()) > -1;
      })
    }
  }

  textValue = (currentTextValue) => {
    if (this.typedValue === undefined) {
      return currentTextValue
    } else {
      return this.typedValue;
    }
  }
}

@observer
class CountryField extends React.Component {
  countryTypeaheadSelector = new TypeaheadSelector();

  @action.bound handleInputClick(event) {
    event.persist();
    if (!this.props.readOnly) {
      this.elmDropdown.handleOpenerClick(event);
      setTimeout(() => {
        event.target.focus();
        event.target.select();
      }, 10)
    }
  }

  @action.bound handleInputChange(event) {
    if (!this.props.readOnly) {
      this.countryTypeaheadSelector.handleChange(event);
      this.elmDropdown.handleOpenerClick(event);
    }
  }

  @action.bound handleInputFocus(event) {
    if (!this.props.readOnly) {
      this.elmDropdown.handleOpenerClick(event);
    }
  }

  @action.bound handleInputBlur(event) {
    if (!this.props.readOnly) {
      this.elmDropdown.handleClose(event);
    }
  }

  @action.bound handleCountryClick(event, country) {
    if (!this.props.readOnly) {
      this.props.form.dirtyValues.country = country.value;
      this.elmDropdown.handleClose(event);
      this.countryTypeaheadSelector.handleNewSelection();
    }
  }

  @action.bound refDropdown(elm) {
    this.elmDropdown = elm;
  }

  render() {
    return (
      <Dropdown ref={this.refDropdown}
        onClose={() => this.props.form.setVisited('country')}>{({ ref, isOpen, onOpen, onClose, onOpenOnly }) => <Observer>{() =>
          <div className={"row" + (!isValid(this.props.form, 'country') ? " error" : "")} ref={ref}>
            <div className="label">
              {translate("country", "Land *")}
            </div>
            <Validations form={this.props.form} fieldName="country" />
            <div className="input">
              <input type="text"
                value={this.countryTypeaheadSelector.textValue(this.props.textValue)}
                onMouseDown={this.handleInputClick}
                onChange={this.handleInputChange}
                onFocus={this.handleInputFocus}
                onBlur={this.handleInputBlur}
                readOnly={this.props.readOnly}
              />
            </div>
            {!this.props.readOnly && <div className={"dropdown" + (isOpen ? "" : " hidden")}>
              <ul>
                {this.countryTypeaheadSelector.filtered(this.props.options).map(country =>
                  <li><a onMouseDown={(event) => this.handleCountryClick(event, country)}>
                    {country.text}
                  </a></li>
                )}
              </ul>
            </div>}
          </div>
        }</Observer>}</Dropdown>
    )
  }
}


function ffProps(form, fieldName) {
  return {
    value: form.values[fieldName],
    onChange: event => form.dirtyValues[fieldName] = event.target.value,
    readOnly: form.readOnlyAll,
    onBlur: () => { form.setVisited(fieldName); },
  }
}

function isValid(form, fieldName) {
  return !form.validations[fieldName] || form.validations[fieldName].length === 0;
}

function makeAddrBlock({ tab, masterData, personalDataForm, isBilling }) {
  return <div className="tab-content_page" id={tab.tabId} key={tab.tabId}>
    {isBilling && <div className="row address-title">
      <h4>{translate("billingAddress", "Rechnungsadresse")}</h4>
    </div>}
    <div className={"row" + (!isValid(tab.form, 'street') ? " error" : "")}>
      <div className="label">
        {translate("street", "Strasse, Nr. *")}
      </div>
      <Validations form={tab.form} fieldName="street" />
      <div className="input">
        <input type="text" {...ffProps(tab.form, 'street')} />
      </div>
    </div>

    <div className={"row" + (!isValid(tab.form, 'addition') ? " error" : "")}>
      <div className="label">
        {translate("addressAddition", "Adresszusatz")}
      </div>
      <Validations form={tab.form} fieldName="addition" />
      <div className="input">
        <input type="text" {...ffProps(tab.form, 'addition')} />
      </div>
    </div>
    <div className={"row" + (!isValid(tab.form, 'postalCode') ? " error" : "")}>
      <div className="label">
        {translate("postNumber", "PLZ *")}
      </div>
      <Validations form={tab.form} fieldName="postalCode" />
      <div className="input">
        <input type="text" {...ffProps(tab.form, 'postalCode')} />
      </div>
    </div>
    <div className={"row" + (!isValid(tab.form, 'city') ? " error" : "")}>
      <div className="label">
        {translate("place", "Ort *")}
      </div>
      <Validations form={tab.form} fieldName="city" />
      <div className="input">
        <input type="text" {...ffProps(tab.form, 'city')} />
      </div>
    </div>
    <CountryField
      textValue={masterData.countryTextByValue(tab.form.values.country)}
      readOnly={tab.form.readOnlyAll}
      form={tab.form}
      options={masterData.optCountries}
    />
  </div>
}

@observer
class Validations extends React.Component {
  render() {
    const { form, fieldName } = this.props;
    return (!isValid(form, fieldName) ?
      <div className="validations">
        <ul>
          {form.validations[fieldName].map(val =>
            <li>{val}</li>
          )}
        </ul>
      </div>
      :
      null
    )
  }
}

@inject(stores => ({
  flasher: stores.app.flasher,
  navigation: stores.app.navigation,
  masterData: stores.app.masterData,
  vUserProfile: stores.app.vUserProfile,
  vUserRegistration: stores.app.vUserRegistration,
  personalDataForm: stores.app.personalDataForm,
  personalAddressForms: stores.app.personalAddressForms,
  authentication: stores.app.authentication,
}))
@observer
export class UserProfile extends React.Component {
  refLinkInput = (element) => {
    this.linkInput = element;
  }

  render() {
    const { flasher, navigation, rentalTransaction, bestOffers, personalDataForm,
      personalAddressForms, loginForm, authentication, masterData, isRegistration,
      vUserProfile, vUserRegistration, step } = this.props;

    //const isRegistration = true;
    //const currency = "CHF";
    const tabDef = [
      { tabId: 'tab-1', form: personalAddressForms[0] },
      { tabId: 'tab-2', form: personalAddressForms[1] },
      // { tabId: 'tab-3', form: personalAddressForms[2] },
    ];
    return (
      <div>
        <SiteHeader />

        {(!isRegistration || (isRegistration && step === '1')) &&
          <section className="profile-container">
            <div className="wrapper">

              <div className="row profile-content">
                <div className="column-12">
                  <h3 className="mali-blue">{isRegistration ? translate("registrationTitle", "Registrieren") : (translate("profileTitle", "Hello ${firstName}", { firstName: personalDataForm.values.firstName }))}</h3>
                  {isRegistration ?
                    <h4 className="mali-blue">{translate("registrationSubtitle", "Registriere dich auf wy.by zu einfach vermieten zumachen.")}</h4>
                    :
                    <h4 className="mali-blue">{translate("profileSubtitle", "Hier kannst du deine Benutzer Daten abwechseln.")}</h4>
                  }
                  {/*Dirty: {JSON.stringify(personalDataForm.isDirty)}*/}
                  <div className="profileInfo-container">
                    <div className="column-6">
                      <div className="row">
                        <h4>{translate("customerInformation", "Kundeninformation")}</h4>
                      </div>
                      <Dropdown onClose={() => personalDataForm.setVisited('salutation')}>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                        <div className={"row" + (!isValid(personalDataForm, 'salutation') ? " error" : "")} ref={ref}>
                          <div className="label">
                            {translate("salutation", "Anrede *")}
                          </div>
                          <Validations form={personalDataForm} fieldName="salutation" />
                          <div className="input" onClick={onOpen}>
                            <input type="text" value={masterData.salutationTextByValue(personalDataForm.values.salutation)}
                              readOnly={personalDataForm.readOnlyAll} />
                          </div>
                          {/*isOpen &&*/ !personalDataForm.readOnlyAll && <div className={"dropdown" + (isOpen ? "" : " hidden")}>
                            <ul>
                              {masterData.optSalutations.map(salutation =>
                                <li><a onClick={() => { personalDataForm.dirtyValues.salutation = salutation.value; onClose() }}>
                                  {salutation.text}
                                </a></li>
                              )}

                            </ul>
                          </div>}
                        </div>
                      }</Observer>}</Dropdown>
                      <div className={"row" + (!isValid(personalDataForm, 'firstName') ? " error" : "")}>
                        <div className="label">
                          {translate("firstName", "Vorname *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="firstName" />
                        <div className="input">
                          <input type="text" {...ffProps(personalDataForm, 'firstName')} />
                        </div>
                      </div>
                      <div className={"row" + (!isValid(personalDataForm, 'lastName') ? " error" : "")}>
                        <div className="label">
                          {translate("lastName", "Nachname *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="lastName" />
                        <div className="input">
                          <input type="text" {...ffProps(personalDataForm, 'lastName')} />
                        </div>
                      </div>
                      <div className={"row" + (!isValid(personalDataForm, 'organization') ? " error" : "")}>
                        <div className="label">
                          {translate("organization", "Organization")}
                        </div>
                        <Validations form={personalDataForm} fieldName="organization" />
                        <div className="input">
                          <input type="text" {...ffProps(personalDataForm, 'organization')} />
                        </div>
                      </div>                      
                      <div className={"row" + (!isValid(personalDataForm, 'email') ? " error" : "")}>
                        <div className="label">
                          {translate("email", "E-Mail *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="email" />
                        <div className="input">
                          <input type="email" {...ffProps(personalDataForm, 'email')} readOnly={!isRegistration} />
                        </div>
                      </div>
                      <div className={"row" + (!isValid(personalDataForm, 'phone') ? " error" : "")}>
                        <div className="label">
                          {translate("phone", "Telefon")}
                        </div>
                        <Validations form={personalDataForm} fieldName="phone" />
                        <div className="input">
                          <input type="tel" {...ffProps(personalDataForm, 'phone')} />
                        </div>
                      </div>
                      <div className={"row" + (!isValid(personalDataForm, 'mobilePhone') ? " error" : "")}>
                        <div className="label">
                          {translate("mobilePhone", "Mobiltelefon")}
                        </div>
                        <Validations form={personalDataForm} fieldName="mobilePhone" />
                        <div className="input">
                          <input type="tel" {...ffProps(personalDataForm, 'mobilePhone')} />
                        </div>
                      </div>
                      {/*<div className={"row" + (!isValid(personalDataForm, 'faxPhone') ? " error" : "")}>
                        <div className="label">
                          Fax
                        </div>
                        <Validations form={personalDataForm} fieldName="faxPhone" />
                        <div className="input">
                          <input type="tel" {...ffProps(personalDataForm, 'faxPhone') } />
                        </div>
                      </div>*/}

                      <Dropdown onClose={() => personalDataForm.setVisited('timeZone')}>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                        <div className={"row" + (!isValid(personalDataForm, 'timeZone') ? " error" : "")} ref={ref}>
                          <div className="label">
                            {translate("timeZone", "Zeitzone")}
                          </div>
                          <Validations form={personalDataForm} fieldName="timeZone" />
                          <div className="input" onClick={onOpen}>
                            <input type="tel" value={masterData.timeZoneTextByValue(personalDataForm.values.timeZone)}
                              readOnly={personalDataForm.readOnlyAll} />
                          </div>
                          {/*isOpen &&*/ <div className={"dropdown" + (isOpen ? "" : " hidden")}>
                            <ul>
                              {masterData.optTimeZones.map(timeZone =>
                                <li><a onClick={() => { personalDataForm.dirtyValues.timeZone = timeZone.value; onClose() }}>
                                  {timeZone.text}
                                </a></li>
                              )}
                            </ul>
                          </div>}
                        </div>
                      }</Observer>}</Dropdown>
                      <Dropdown onClose={() => personalDataForm.setVisited('language')}>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                        <div className={"row" + (!isValid(personalDataForm, 'language') ? " error" : "")} ref={ref}>
                          <div className="label">
                            {translate("language", "Sprache")}
                          </div>
                          <Validations form={personalDataForm} fieldName="language" />
                          <div className="input" onClick={onOpen}>
                            <input type="tel" value={masterData.languageTextByValue(personalDataForm.values.language)}
                              readOnly={personalDataForm.readOnlyAll} />
                          </div>
                          {/*isOpen &&*/ <div className={"dropdown" + (isOpen ? "" : " hidden")}>
                            <ul>
                              {masterData.optLanguages.map(language =>
                                <li><a onClick={() => { personalDataForm.dirtyValues.language = language.value; onClose() }}>
                                  {language.text}
                                </a></li>
                              )}
                            </ul>
                          </div>}
                        </div>
                      }</Observer>}</Dropdown>
                    </div>
                    <div className="column-6">
                      <div className="row address-title">
                        <h4>{translate("postalAddress", "Post Adresse")}</h4>
                      </div>
                      <div className="row">
                        <div className="post-address-container">
                          {makeAddrBlock({ tab: tabDef[0], masterData, personalDataForm, isBilling: false })}
                          <div className="use-same-address">
                            <input type="checkbox"
                              checked={(isRegistration ? (!vUserRegistration.usingPostAsBilling) : (!vUserProfile.usingPostAsBilling))}
                              onClick={(isRegistration ? vUserRegistration.usePostAsBilling : vUserProfile.usePostAsBilling)}
                            /> {translate("useDifferentBillingAddress", "Use different address for billing.")}
                          </div>
                        </div>
                        <div className="billing-address-container">
                          {(isRegistration ? (!vUserRegistration.usingPostAsBilling) :
                            (!vUserProfile.usingPostAsBilling)) &&
                            makeAddrBlock({ tab: tabDef[1], masterData, personalDataForm, isBilling: true })
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="profilePassword-container">
                    <div className="column-12">
                      <div className="row">
                        <h4>{translate("password", "Passwort")}</h4>
                      </div>
                    </div>
                    <div className="column-6">
                      {!isRegistration && <div className="row">
                        <div className="label">
                          {translate("userNameReadOnly", "Benutzername")}
                        </div>
                        <div className="input">
                          <span className="usrName">{authentication.userName}</span>
                        </div>
                      </div>}
                      {isRegistration && <div className={"row" + (!isValid(personalDataForm, 'userName') ? " error" : "")}>
                        <div className="label">
                          {translate("userNameEditable", "Benutzername *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="userName" />
                        <div className="input">
                          <input type="text" {...ffProps(personalDataForm, 'userName')} />
                        </div>
                      </div>}
                      {!isRegistration && <div className={"row" + (!isValid(personalDataForm, 'oldPassword') ? " error" : "")}>
                        <div className="label">
                          {translate("oldPassword", "Altes Passwort")}
                        </div>
                        <Validations form={personalDataForm} fieldName="oldPassword" />
                        <div className="input">
                          <input type="password" {...ffProps(personalDataForm, 'oldPassword')} />
                        </div>
                      </div>}
                    </div>
                    <div className="column-6">
                      <div className={"row" + (!isValid(personalDataForm, 'password1') ? " error" : "")}>
                        <div className="label">
                          {translate("newPassword1", "Neues Passwort *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="password1" />
                        <div className="input">
                          <input type="password" {...ffProps(personalDataForm, 'password1')} />
                        </div>
                      </div>
                      <div className={"row" + (!isValid(personalDataForm, 'password2') ? " error" : "")}>
                        <div className="label">
                          {translate("newPassword2", "Passwort bestätigen *")}
                        </div>
                        <Validations form={personalDataForm} fieldName="password2" />
                        <div className="input">
                          <input type="password" {...ffProps(personalDataForm, 'password2')} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="profileTerms-container">
                    <div className="column-6">
                      {isRegistration && <div>
                        <input type="checkbox"
                          onClick={vUserRegistration.handleAGBClick}
                          checked={vUserRegistration.agbChecked} />{translate("acceptAgb", "Ich akzeptiere die wy.by Demo")} <a target="_blank" href="https://wyby.ch/de-ch/AGB">{translate("agb", "AGB")}</a></div>}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row profileBtns-container">
                <div className="column-6">
                  <a className="back" onClick={navigation.goHome}><i className="fa fa-times" aria-hidden="true"></i> {translate("back", "Abbrechen")}</a> {/* TODO: different button caption */}
                </div>
                {isRegistration ?
                  <div className="column-6">
                    <a className={"forward" + (vUserRegistration.agbChecked ? "" : " disabled")}
                      onClick={vUserRegistration.agbChecked && vUserRegistration.createNewLessee}>
                      {translate("registrationSave", "Speichern")} <i className="fa fa-floppy-o" aria-hidden="true"></i>
                    </a>
                  </div>
                  :
                  <div className="column-6">
                    <a className="forward" onClick={vUserProfile.updateProfile}>{translate("profileSave", "Speichern")} <i className="fa fa-floppy-o" aria-hidden="true"></i></a>
                  </div>
                }
              </div>

            </div>
          </section>
        }

        {isRegistration && step === '2' &&
          <section className="profile-container">
            <div className="wrapper">
              <div className="row profile-content">
                <div className="column-12">
                  <h3 className="mali-blue">{translate("registrationStep2Title", "Registration")}</h3>
                  <h4 className="mali-blue">{translate("registrationStep2Subtitle", "Vielen Dank für deine Registrierung.")}</h4>
                  <div className="registersSuccess-container">
                    <div className="row">
                      <p>{translate("registrationStep2Text", "Please follow a link in your email to activate the account.")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row registersSuccessBtns-container">
                <div className="column-3 offset-6">
                  <a className="forward" onClick={navigation.goHome}>{translate("registrationStep2GoHome", "Go home")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                </div>
              </div>
            </div>
          </section>
        }

        {isRegistration && step === '3' &&
          null
        }

        {isRegistration && step === '4' &&
          <section className="profile-container">
            <div className="wrapper">
              <div className="row profile-content">
                <div className="column-12">
                  <h3 className="mali-blue">{translate("registrationStep4Title", "Registration")}</h3>
                  <div className="registersSuccess-container">
                    <div className="row">
                      <p>{translate("registrationStep4Subtitle", "Dein Registrierung ist kopmplett.")}</p>
                      {/* <p>{vUserRegistration.message}</p> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row registersSuccessBtns-container">
                <div className="column-3 offset-6">
                  <a className="forward" onClick={navigation.goHome}>{translate("registrationStep4GoHome", "Go home")} <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                </div>
              </div>
            </div>
          </section>
        }
        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/UserProfile.js